// extracted by mini-css-extract-plugin
module.exports = {"chart":"ProductViews_chart__255Mj","viewHead":"ProductViews_viewHead__2kTpb","loaderWrap":"ProductViews_loaderWrap__csqJY","dropdown1":"ProductViews_dropdown1__1dohT"};